export class FeedbackClassification {
  static Good = 0
  static Bad = 1
}
